export const VIDEO = {
  script: 'https://fast.wistia.com/embed/medias/63eyaiuaqq.jsonp',
  id: 'wistia_async_63eyaiuaqq',
};
